import { render, staticRenderFns } from "./export-proof-edit-general.vue?vue&type=template&id=651cf569"
import script from "./export-proof-edit-general.vue?vue&type=script&lang=ts"
export * from "./export-proof-edit-general.vue?vue&type=script&lang=ts"
import style0 from "./export-proof-edit-general.vue?vue&type=style&index=0&id=651cf569&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports